import { computed, ref, watch } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import useBalance from "@/hooks/useBalance";
import providers from "@/lib/api";

export default function usePendingPrimaryBalance() {
  const { balance, getBalance } = useBalance();
  const { authUserStrict } = useAuthUser();
  const pendingBalance = ref<number>(0);
  const primaryBalance = computed<number>(() => balance.value - pendingBalance.value);
  const getPendingBalance = async () => {
    const balance = await providers.TransactionProvider.getPendingBalance({ userIds: [authUserStrict.value.id] });
    pendingBalance.value = balance[authUserStrict.value.id] ?? 0;
  };
  watch(
    balance,
    () => {
      getPendingBalance();
    },
    { immediate: true }
  );

  return {
    pendingBalance,
    primaryBalance,
    getBalance,
  };
}
